import React from "react";

// Renders a graphic asset by kind. Non-text kinds use SVG (preserveAspectRatio none
// so they fill the box); text kinds render styled uppercase text.
const TEXT_KINDS = {
  "text-start": "START", "text-finish": "FINISH", "text-sled": "SLED",
  "text-sprint": "SPRINT", "text-push": "PUSH", "text-pull": "PULL",
};

export function isTextKind(kind) { return kind in TEXT_KINDS; }

export function GraphicSVG({ kind, colour = "#f5f5f0" }) {
  if (isTextKind(kind)) {
    return (
      <div className="w-full h-full flex items-center justify-center leading-none"
        style={{ color: colour, fontFamily: "Anton, sans-serif", letterSpacing: "0.04em",
          fontSize: "clamp(8px, 60cqh, 400px)" }}>
        <span style={{ fontSize: "min(100%, 1000px)" }} className="w-full text-center block">{TEXT_KINDS[kind]}</span>
      </div>
    );
  }
  const c = colour;
  const svg = (children) => (
    <svg viewBox="0 0 100 100" preserveAspectRatio="none" width="100%" height="100%">{children}</svg>
  );
  switch (kind) {
    case "arrow-single":
    case "arrow-large":
    case "arrow-direction":
      return svg(<polygon points="0,28 60,28 60,4 100,50 60,96 60,72 0,72" fill={c} />);
    case "arrow-double":
      return svg(<><polygon points="0,50 45,2 45,98" fill={c} /><polygon points="55,50 100,2 100,98" fill={c} /></>);
    case "arrow-triple":
    case "chevron": {
      const n = kind === "arrow-triple" ? 3 : 2;
      const parts = [];
      for (let i = 0; i < n; i++) { const o = 100 * (i / (n + 0.4));
        parts.push(<polygon key={i} points={`${o},50 ${o+28},2 ${o+40},2 ${o+12},50 ${o+40},98 ${o+28},98`} fill={c} />); }
      return svg(parts);
    }
    case "metre-line":
    case "start-end-line":
    case "rectangle":
      return svg(<rect x="0" y="0" width="100" height="100" fill={c} />);
    case "line":
    case "lane-divider":
      return svg(<rect x="0" y="42" width="100" height="16" fill={c} />);
    case "metre-line-number":
      return svg(<><rect x="42" y="0" width="16" height="60" fill={c} /><text x="50" y="95" fill={c} fontSize="34" fontFamily="Anton" textAnchor="middle">10</text></>);
    case "numbered-sequence": {
      const parts = [];
      for (let i = 0; i < 5; i++) { const x = (i / 5) * 100;
        parts.push(<g key={i}><rect x={x} y="0" width="2" height="50" fill={c} /><text x={x} y="95" fill={c} fontSize="26" fontFamily="Anton">{i * 2}</text></g>); }
      return svg(parts);
    }
    case "centre-marker":
      return svg(<><circle cx="50" cy="50" r="44" fill="none" stroke={c} strokeWidth="7" /><rect x="47" y="0" width="6" height="100" fill={c} /></>);
    case "agility-ladder": {
      const parts = [<rect key="a" x="0" y="0" width="100" height="8" fill={c} />, <rect key="b" x="0" y="92" width="100" height="8" fill={c} />];
      for (let i = 1; i < 6; i++) parts.push(<rect key={i} x={(i / 6) * 100} y="0" width="3" height="100" fill={c} />);
      return svg(parts);
    }
    case "circle":
      return svg(<circle cx="50" cy="50" r="48" fill={c} />);
    case "hexagon":
      return svg(<polygon points="25,6 75,6 98,50 75,94 25,94 2,50" fill={c} />);
    case "ring":
      return svg(<circle cx="50" cy="50" r="42" fill="none" stroke={c} strokeWidth="13" />);
    case "diamond":
      return svg(<polygon points="50,2 98,50 50,98 2,50" fill={c} />);
    case "triangle":
      return svg(<polygon points="50,4 96,96 4,96" fill={c} />);
    case "block":
      return svg(<rect x="6" y="16" width="88" height="68" rx="6" fill={c} />);
    case "angular":
      return svg(<polygon points="22,4 100,4 78,96 0,96" fill={c} />);
    case "target-circle":
      return svg(<><circle cx="50" cy="50" r="46" fill="none" stroke={c} strokeWidth="6" /><circle cx="50" cy="50" r="22" fill={c} /></>);
    case "training-box":
    case "outlined-box":
      return svg(<rect x="6" y="6" width="88" height="88" fill="none" stroke={c} strokeWidth="7" />);
    case "hash-marks": {
      const parts = [];
      for (let i = 0; i < 8; i++) parts.push(<rect key={i} x={(i / 8) * 100} y="0" width="2.5" height="100" fill={c} />);
      return svg(parts);
    }
    default:
      return svg(<rect x="0" y="0" width="100" height="100" fill={c} />);
  }
}
